import { render, staticRenderFns } from "./TheDisclaimerScreen.vue?vue&type=template&id=2f458344&"
import script from "./TheDisclaimerScreen.vue?vue&type=script&lang=js&"
export * from "./TheDisclaimerScreen.vue?vue&type=script&lang=js&"
import style0 from "./TheDisclaimerScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports